import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background-color: var(--color-white);
  position: relative;
  padding-top: 8px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

export const Title = styled.p`
  margin: 0;
  margin-right: auto;
  font-size: 14px;
  color: var(--color-text-secondary);
  //color: ${({ isFromEdit }) => (isFromEdit ? 'var(--color-text-secondary)' : 'var(--color-text-primary)')};
`

export const Form = styled.div`
  display: flex;
  margin-top: 8px;
  width: 100%;
  gap: 0.5rem;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
`

export const DisableScreen = styled.div`
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  bottom: 0;
  opacity: 0.3;
  background-color: var(--color-selago-grey);
`

export const Textarea = styled.textarea<{ isError: boolean }>`
  position: relative;
  width: 100%;
  height: 110px;
  font-size: 14px;
  word-break: break-word;
  outline: none;
  border: none;
  border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
`

export const Error = styled.div`
  font-size: 12px;
  position: relative;
  color: var(--color-text-error);
  margin-top: -0.5rem;
  margin-right: auto;
`

export const InputContainer = styled.div<{ isError: boolean }>`
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 10px;

  * {
    padding: 1rem;
    border-radius: inherit;
  }

  & input {
    font-weight: 600;
    font-size: 14px;
    color: rgb(68, 68, 68);
    border-color: rgb(229, 229, 229);
    border-bottom: none;
    border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
  }
`

export const TitleInput = styled.input`
  font-weight: 600;
  font-size: 14px;
  color: rgb(68, 68, 68);
  border: none;
  outline: none;
  width: 100%;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  width: 100%;
  gap: 8px;
  position: relative;
  justify-content: flex-end;
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  gap: 0.5rem 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const RowCell = styled.div<{ isError: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`
